import { api } from "../api";
export const loginApi = (params) => {
  return api.post("/api/admin/login", JSON.stringify(params));
};
